import RestClient from './../../service/rest-client';
import WarehouseViewTypeEnum from './WarehouseViewTypeEnum';
import {Signal} from 'signals';
import _ from 'underscore';
import moment from 'moment';

class Service {

    event = {
        onPackageCheckInTimeByOperator: new Signal(),
        onPackageStatsError: new Signal()
    };
    // start accounts without sent shipment code
    fetchWarehouseReports(page, searchParams, viewType) {
        page = page || 1;
        var limit = 10, pageSize = 10,
            offset = (page - 1) * pageSize;

        RestClient.isSessionActive();
        var queryParams = [`offset=${ offset }`, `limit=${ limit }`];

        if (searchParams.createdDateStart) {
            queryParams.push(`start=${ searchParams.createdDateStart }`)
        }

        if (searchParams.createdDateEnd) {
            queryParams.push(`end=${ searchParams.createdDateEnd }`)
        }

        if (searchParams.shipDateStart) {
            queryParams.push(`date_start=${ searchParams.shipDateStart }`)
        }

        if (searchParams.shipDateEnd) {
            queryParams.push(`date_end=${ searchParams.shipDateEnd }`)
        }

        if (searchParams.intervalOfDays) {
            queryParams.push(`interval_days=${ searchParams.intervalOfDays }`)
        }

        if (searchParams.countryCode) {
            queryParams.push(`country_code=${ searchParams.countryCode }`)
        }

        var urlRequestEndPointString = "";

        if (viewType === WarehouseViewTypeEnum.PackageCheckInTimeByOperator) {
            urlRequestEndPointString = "/reporting/packagestats/operation" + "?";
        } else if (viewType === WarehouseViewTypeEnum.ErrorPackageCheckInsByWorker) {
            urlRequestEndPointString = "/reporting/packagestats/operation-errors" + "?";
        }

        var urlRequestTemplate = urlRequestEndPointString + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var page = data.page_number;
            var pageSize = data.page_size,
                offset = (page - 1) * pageSize;
            var pagingMetadata = {
                page: data.page_number,
                startIndex: offset + 1,
                endIndex: offset + pageSize,
                totalCount: data.total_count,
                pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
            };
            data.pagingMetadata = pagingMetadata;

            if (viewType === WarehouseViewTypeEnum.PackageCheckInTimeByOperator) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onPackageCheckInTimeByOperator.dispatch(data);
            } else if (viewType === WarehouseViewTypeEnum.ErrorPackageCheckInsByWorker) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onPackageStatsError.dispatch(data);
            }

        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseResultData(resultData, viewType) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = dataItem;

            if (viewType === WarehouseViewTypeEnum.PackageCheckInTimeByOperator) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === WarehouseViewTypeEnum.ErrorPackageCheckInsByWorker) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            }

            return parsedObject;
        });
        return parsedArray;
    }

    downloadCannedAccountReport(searchParams, viewType) {
        RestClient.isSessionActive();
        var queryParams = [];

        if (searchParams.createdDateStart) {
            queryParams.push(`created_date_start=${ searchParams.createdDateStart }`)
        }

        if (searchParams.createdDateEnd) {
            queryParams.push(`created_date_end=${ searchParams.createdDateEnd }`)
        }

        if (searchParams.shipDateStart) {
            queryParams.push(`date_start=${ searchParams.shipDateStart }`)
        }

        if (searchParams.shipDateEnd) {
            queryParams.push(`date_end=${ searchParams.shipDateEnd }`)
        }

        if (searchParams.intervalOfDays) {
            queryParams.push(`interval_days=${ searchParams.intervalOfDays }`)
        }

        if (searchParams.countryCode) {
            queryParams.push(`country_code=${ searchParams.countryCode }`)
        }

        var urlRequestTemplate = "";
        var urlRequestEndPointString = "";

        if (viewType === WarehouseViewTypeEnum.PackageCheckInTimeByOperator) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutsentshipment/file";
        } else if (viewType === WarehouseViewTypeEnum.AccountWithoutReceivedPackage) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutreceivedpackage/file";
        } else if (viewType === WarehouseViewTypeEnum.AccountSortBySentShipments) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbysentshipments/file";
        } else if (viewType === WarehouseViewTypeEnum.AccountSortByRevenue) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbyrevenue/file";
        } else if (viewType === WarehouseViewTypeEnum.InactiveAccountForTimePeriod) {
            urlRequestEndPointString = "/reporting/cannedreport/inactiveaccountsfortimeperiod/file";
        } else if (viewType === WarehouseViewTypeEnum.ShipmentsWithCoupons) {
            urlRequestEndPointString = "/reporting/cannedreport/shipmentswithcoupons/file";
        } else if (viewType === WarehouseViewTypeEnum.SentShipmentsByMonth) {
            urlRequestEndPointString = "/reporting/cannedreport/sentshipmentsbymonth/file";
        }

        if (queryParams.length > 0) {
            urlRequestTemplate = urlRequestEndPointString + "?" + queryParams.join("&");
            RestClient.downloadFile(urlRequestTemplate, true);
        } else {
            urlRequestTemplate = urlRequestEndPointString;
            RestClient.downloadFile(urlRequestTemplate, false);
        }
    }

} export default new Service();
